import { render, staticRenderFns } from "./LogisticsData.vue?vue&type=template&id=6a5faa3b&scoped=true"
import script from "./LogisticsData.vue?vue&type=script&lang=js"
export * from "./LogisticsData.vue?vue&type=script&lang=js"
import style0 from "./LogisticsData.vue?vue&type=style&index=0&id=6a5faa3b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5faa3b",
  null
  
)

export default component.exports